export default [
  {
    name: 'default_footer',
    path: 'modules/pages/default/footers/FooterDefault'
  }
]
